export const USER_STORY_TEMPLATE = `
### Why


**As personaName**
**I want**
**So that**

### Acceptance Criteria

\`\`\`gherkin
Scenario: 
Given
When
Then
\`\`\`

**Notes:**
`.trimStart()

export const BUG_REPORT_TEMPLATE = `
### Steps to reproduce
1. 
2. 
3. 

### Expected


### Actual

`.trimStart()
